import { types } from 'mobx-state-tree';
var StickyGridSectionHeaderMetadata = types.model({
    stickySectionIndex: types.maybe(types.number)
})
    .named('StickyGridSectionHeaderMetadata')
    .actions(function (self) { return ({
    setStickySectionIndex: function (stickySectionIndex) {
        console.log('SET stickySectionIndex', stickySectionIndex);
        self.stickySectionIndex = stickySectionIndex;
    },
}); });
export default StickyGridSectionHeaderMetadata;
//# sourceMappingURL=StickyGridSectionHeaderMetadata.js.map